export var RegisterWayType;
(function (RegisterWayType) {
    RegisterWayType["MANUAL"] = "manual";
    RegisterWayType["AUTO"] = "auto";
})(RegisterWayType || (RegisterWayType = {}));
//# sourceMappingURL=RegisterWayType.js.map